export default "__VITE_ASSET__CXNbvHzf__"